import React from 'react';
import PropTypes from 'prop-types';

import { REGEXP_EMAIL } from 'constants/contraintes.constants';
import { Col, InputControl, Row, SelectControl } from '@si-armes/dsfr-react';
import { checkPrenom } from 'utils/utils';
import { useFormContext } from 'react-hook-form';
import { MAX_EMAIL_LENGTH, MAX_NAME_LENGTH } from 'utils/ConstanteNumerique';

const EmployeForm = ({ update }) => {
    const { register, watch, formState } = useFormContext();

    const prenomUn = watch('prenomUn');
    const prenomDeux = watch('prenomDeux');
    const prenomTrois = watch('prenomTrois');

    return (
        <div className="margin-top-sm">
            <p>
                Les champs marqués d&apos;un <span className="symbol-required">*</span> sont
                obligatoires
            </p>

            <Row gutters>
                <Col col={12} lg={4}>
                    <InputControl
                        label="Nom *"
                        type="text"
                        maxLength={MAX_NAME_LENGTH}
                        id="nom"
                        uppercase
                        {...register('nom', {
                            required: 'Le nom est obligatoire',
                            maxLength: {
                                value: MAX_NAME_LENGTH,
                                message: `Le nom ne peut pas dépasser ${MAX_NAME_LENGTH} caractères.`,
                            },
                        })}
                        state={formState.errors?.nom ? 'error' : null}
                        message={formState.errors?.nom?.message}
                    />
                </Col>

                <Col col={12} lg={4}>
                    <InputControl
                        label="Premier prénom *"
                        type="text"
                        maxLength={MAX_NAME_LENGTH}
                        id="prenomUn"
                        uppercase
                        {...register('prenomUn', {
                            required: 'Le premier prénom est obligatoire',
                            maxLength: {
                                value: MAX_NAME_LENGTH,
                                message: `Le prénom ne peut pas dépasser ${MAX_NAME_LENGTH} caractères.`,
                            },
                        })}
                        state={formState.errors?.prenomUn ? 'error' : null}
                        message={formState.errors?.prenomUn?.message}
                    />
                </Col>

                <Col col={12} lg={4}>
                    <InputControl
                        label="Deuxième prénom"
                        type="text"
                        maxLength={MAX_NAME_LENGTH}
                        id="prenomDeux"
                        uppercase
                        disabled={checkPrenom([prenomUn])}
                        {...register('prenomDeux', {
                            maxLength: {
                                value: MAX_NAME_LENGTH,
                                message: `Le prénom ne peut pas dépasser ${MAX_NAME_LENGTH} caractères.`,
                            },
                        })}
                        state={formState.errors?.prenomDeux ? 'error' : null}
                        message={formState.errors?.prenomDeux?.message}
                    />
                </Col>
            </Row>

            <Row gutters>
                <Col col={12} lg={4}>
                    <InputControl
                        label="Troisième prénom"
                        type="text"
                        maxLength={MAX_NAME_LENGTH}
                        id="prenomTrois"
                        uppercase
                        disabled={checkPrenom([prenomUn, prenomDeux])}
                        {...register('prenomTrois', {
                            maxLength: {
                                value: MAX_NAME_LENGTH,
                                message: `Le prénom ne peut pas dépasser ${MAX_NAME_LENGTH} caractères.`,
                            },
                        })}
                        state={formState.errors?.prenomTrois ? 'error' : null}
                        message={formState.errors?.prenomTrois?.message}
                    />
                </Col>
                <Col col={12} lg={4}>
                    <InputControl
                        label="Quatrième prénom"
                        type="text"
                        maxLength={MAX_NAME_LENGTH}
                        id="prenomQuatre"
                        uppercase
                        disabled={checkPrenom([prenomUn, prenomDeux, prenomTrois])}
                        {...register('prenomQuatre', {
                            maxLength: {
                                value: MAX_NAME_LENGTH,
                                message: `Le prénom ne peut pas dépasser ${MAX_NAME_LENGTH} caractères.`,
                            },
                        })}
                        state={formState.errors?.prenomQuatre ? 'error' : null}
                        message={formState.errors?.prenomQuatre?.message}
                    />
                </Col>

                <Col col={12} lg={4}>
                    <InputControl
                        label="Email *"
                        type="email"
                        maxLength={MAX_EMAIL_LENGTH}
                        id="email"
                        {...register('email', {
                            required: 'L’email est obligatoire',
                            pattern: {
                                value: REGEXP_EMAIL,
                                message: "Le courriel n'est pas correct.",
                            },
                        })}
                        state={formState.errors?.email ? 'error' : null}
                        message={formState.errors?.email?.message}
                    />
                </Col>
            </Row>

            {update && (
                <Row className="margin-top-sm">
                    <Col col={12} lg={3}>
                        <SelectControl
                            id="actif"
                            label="Activer/désactiver le compte"
                            uppercase
                            options={[
                                {
                                    name: 'Inactif',
                                    value: false,
                                },
                                {
                                    name: 'Actif',
                                    value: true,
                                },
                            ]}
                            {...register('actif', {
                                setValueAs: (v) => v === 'true' || v === true,
                            })}
                        />
                    </Col>
                </Row>
            )}
        </div>
    );
};

EmployeForm.propTypes = {
    update: PropTypes.bool,
    prenomUn: PropTypes.string,
    prenomDeux: PropTypes.string,
    prenomTrois: PropTypes.string,
};

export default EmployeForm;
